import React from "react";
import "../../../styles/desktop/FallStickerPage.css";
import Fade from "react-reveal/Fade";
import { HStack, VStack, Stack, Box, Text, Image } from "@chakra-ui/react";

const SperoBearPage = () => {
  return (
    <Stack
      direction={{ base: "column", lg: "row" }}
      spacing="1.5rem"
      ml={{ base: "0", sm: "1rem" }}
      mt={{ base: "10px", sm: "none" }}
    >
      <HStack>
        <VStack spacing="5px">
          <Fade bottom>
            <Box
              display="flex"
              justifyContent="center"
              align-items="center"
              overflow="hidden"
              width={{ base: "80vw", sm: "60vw", lg: "40vw" }}
              height={{ base: "20vh", sm: "40vh", lg: "40vh" }}
            >
              <Image
                src={require("../../../images/design-photos/bear-graphic.jpg")}
                alt="main-sticker"
                objectFit="cover"
                w="100%"
                h="100%"
              />
            </Box>
          </Fade>
          <HStack spacing="5px">
            <Fade bottom>
              <Box
                display="flex"
                justifyContent="center"
                align-items="center"
                overflow="hidden"
                width={{
                  base: "39vw",
                  sm: "29.75vw",
                  lg: "19.75vw",
                }}
                height={{
                  base: "20vh",
                  sm: "20vh",
                  lg: "20vh",
                }}
              >
                <Image
                  src={require("../../../images/design-photos/three-stickers-drawing.jpg")}
                  alt=""
                  objectFit="cover"
                  w="100%"
                  h="100%"
                />
              </Box>
            </Fade>

            <Fade bottom>
              <Box
                display="flex"
                justifyContent="center"
                align-items="center"
                overflow="hidden"
                width={{
                  base: "39vw",
                  sm: "29.75vw",
                  lg: "19.75vw",
                }}
                height={{
                  base: "20vh",
                  sm: "20vh",
                  lg: "20vh",
                }}
              >
                <Image
                  src={require("../../../images/design-photos/bear-right.jpg")}
                  alt=""
                  objectFit="cover"
                  w="100%"
                  h="100%"
                />
              </Box>
            </Fade>
          </HStack>
        </VStack>
      </HStack>
      <VStack textAlign="left" justifyContent="center" maxW="500px">
        <VStack alignItems="flex-start">
          <Fade bottom>
            <HStack alignItems="flex-start">
              <Text
                fontFamily="Lexend Deca"
                fontSize={{ base: "30px", sm: "45px" }}
                lineHeight={{ base: "35px", sm: "60px" }}
              >
                <b>SPERO</b> <br />
                BEAR
              </Text>
              <Box
                bgColor="#5c6a6f"
                px={{ base: "4px", sm: "7px" }}
                py={{ base: "2px", sm: "5px" }}
              >
                <Text
                  fontFamily="Lexend Deca"
                  fontSize={{ base: "7px", sm: "10px" }}
                  color="white"
                >
                  STICKER COLLECTION
                </Text>
              </Box>
            </HStack>
          </Fade>
          <Fade bottom>
            <Text
              fontFamily="Tenor Sans"
              fontSize={{ base: "10px", sm: "12px" }}
              py="10px"
            >
              <b>78</b> because of the tender mercy of our God,
              <br />
              by which the rising sun will come to us from heaven
              <br />
              <br />
              <b>79</b> to shine on those living in darkness and in the shadow
              of death,
              <br />
              to guide our feet into the path of peace.”
              <br />
              <br />
              <b>Luke 1:78-79</b>
            </Text>
          </Fade>
          <Fade bottom>
            <Text
              fontFamily="Lexend Deca"
              fontSize={{ base: "10px", sm: "12px" }}
            >
              Our Redeemed Bear sticker was inspired by Luke 1:78. We hope that,
              despite its seemingly simple design, this sticker will bridge
              connections between both familiar and unfamiliar faces, as well as
              between you and your faith! Created with the intention of sharing
              God’s saving grace, we hope that this sticker will help to guide
              you into a path of peace.
            </Text>
          </Fade>
          <Box h={{ base: "30px", sm: "0px" }}></Box>
        </VStack>
      </VStack>
    </Stack>
    // <div className="sticker-container">
    //     <Fade bottom>
    //         <div className="left-display">
    //             <div class="fill">
    //                 <img
    //                     src={require('../../../images/design-photos/bear-graphic.jpg')}
    //                     alt="main-sticker"
    //                 />
    //             </div>
    //             <div className="smaller-container">
    //                 <div class="fill-fifth leftmost">
    //                     <img
    //                         src={require('../../../images/design-photos/three-stickers-drawing.jpg')}
    //                         alt=""
    //                     />
    //                 </div>
    //                 <div class="fill-fifth">
    //                     <img
    //                         src={require('../../../images/design-photos/bear-right.jpg')}
    //                         alt=""
    //                     />
    //                 </div>
    //             </div>
    //         </div>
    //     </Fade>

    //     <div className="right-display">
    //         <div className="text-box">
    //             <Fade bottom>
    //                 <div className="sticker-title">
    //                     SPERO <br />
    //                     BEAR (sticker)
    //                 </div>

    //                 <div className="sticker-bible">
    //                     <b>78</b> because of the tender mercy of our God,
    //                     <br />
    //                     by which the rising sun will come to us from heaven
    //                     <br />
    //                     <br />
    //                     <b>79</b> to shine on those living in darkness and
    //                     in the shadow of death,
    //                     <br />
    //                     to guide our feet into the path of peace.”
    //                     <br />
    //                     <br />
    //                     <b>Luke 1:78-79</b>
    //                 </div>

    //                 <div className="sticker-description">
    //                     Our Redeemed Bear sticker was inspired by Luke 1:78.
    //                     We hope that, despite its seemingly simple design,
    //                     this sticker will bridge connections between both
    //                     familiar and unfamiliar faces, as well as between
    //                     you and your faith! Created with the intention of
    //                     sharing God’s saving grace, we hope that this
    //                     sticker will help to guide you into a path of peace.
    //                 </div>

    //                 <div className="button-format">
    //                     <div className="shop-btn-stickerpage">
    //                         <a href="http://tinyurl.com/spero-etsy">
    //                             <h4 className="shop-text">
    //                                 SHOP NOW ON ETSY
    //                             </h4>
    //                         </a>
    //                     </div>
    //                 </div>
    //             </Fade>
    //         </div>
    //     </div>
    // </div>
  );
};

export default SperoBearPage;
